module.exports = __webpack_public_path__ + "img/efficiency.16461b16.png";